import { render } from "./ReportsMain.vue?vue&type=template&id=af9e47e4"
import script from "./ReportsMain.vue?vue&type=script&lang=js"
export * from "./ReportsMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__